module.exports = __webpack_public_path__ + "static/media/FreeDance_Low_Impact_Dance_Fitness_2.1e25a08e.webp";